(function () {
  const SECTIONS = [
    { id: 'multicolumn_Uw7cHh', direction: 'left', width: '200px' },
    { id: 'multicolumn_cFG8iD', direction: 'right', width: '350px' },
    { id: 'multicolumn_4thhrM', direction: 'left', width: '200px' },
    { id: 'multicolumn_6dYAtY', direction: 'left', width: '200px' },
    { id: 'multicolumn_nGMMky', direction: 'left', width: '200px' },
    { id: 'multicolumn_VLQE4b', direction: 'right', width: '350px' },
  ];

  function initMarquee() {
    SECTIONS.forEach(({ id, direction, width }) => {
      const section = document.querySelector(`[id*="${id}"]`);
      if (!section) return;

      const sliderComponent = section.querySelector('slider-component');
      if (!sliderComponent) return;

      const list = sliderComponent.querySelector('.multicolumn-list');
      if (!list) return;

      const items = Array.from(list.querySelectorAll('.multicolumn-list__item'));
      if (!items.length) return;

      items.forEach(item => {
        item.querySelectorAll('img').forEach(img => {
          img.loading = 'eager';
          if (img.dataset.src) img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        });
      });

      const track = document.createElement('div');
      track.className = 'pinets-marquee-track';

      [0, 1, 2, 3].forEach(() => {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.remove('slider__slide', 'scroll-trigger', 'animate--slide-in');
          clone.removeAttribute('data-cascade');
          clone.style.cssText = `flex: 0 0 auto; width: ${width};`;
          track.appendChild(clone);
        });
      });

      const wrap = document.createElement('div');
      wrap.className = `pinets-marquee-wrap pinets-marquee--${direction}`;
      wrap.appendChild(track);

      sliderComponent.parentNode.replaceChild(wrap, sliderComponent);
    });
  }

  window.addEventListener('load', initMarquee);
})();
